import { render, staticRenderFns } from "./StatisticsWebHelp.vue?vue&type=template&id=8a360d72&"
import script from "./StatisticsWebHelp.vue?vue&type=script&lang=js&"
export * from "./StatisticsWebHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports